.component {
  margin: 23px var(--margin) 20px 20px;
  overflow: auto;
  height: 100%;
}

.title {
  margin-bottom: 10px;
  font-size: 26px;
  font-weight: 300;
  color: var(--tealish);
}

.subTitle {
  width: 580px;
  font-size: 14px;
  color: var(--marine);
}

.section {
  margin-top: 28px;
}

.loadingText {
  font-size: 13px;
  color: var(--brown-grey);
}

.connectionRow {
  width: 560px;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.25);
  margin-bottom: 4px;
  padding: 0 10px;
  background-color: var(--fully-white);
}

.connectionRow:nth-child(even) {
  background-color: var(--light-grey);
}

.connectionName {
  flex: 1;
  font-size: 14px;
  color: var(--marine);
  font-weight: 500;
}

.connectionMember {
  font-size: 12px;
  color: var(--brown-grey);
  margin-right: 14px;
}

.connectionDate {
  font-size: 12px;
  color: var(--brown-grey);
  margin-right: 10px;
}

.trash {
  width: 11.4px;
  height: 12.3px;
  padding: 10px;
  object-fit: contain;
  cursor: pointer;
}
